var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShown)?_c('aside',{staticClass:"toast"},[_c('button',{staticClass:"toast__close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeToast}},[_c('CloseSVG',{staticClass:"icon"})],1),_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }